export default __webpack_public_path__ + "static/media/illustration_writing.f2ee820a.png";